import { useState } from 'react';
import { text, type Locale } from '../shared/content';
type NewsRow = { id: string; title: string; createdAt: string; publicHidden: boolean };
const copy = {
  info: text(
    'Only platform administrators can withdraw or restore public city articles. Source events are preserved.',
    '只有平台管理员可以撤下或恢复公开城市文章，原始事件记录会保留。',
    '只有平台管理員可以撤下或恢復公開城市文章，原始事件記錄會保留。',
    'Solo los administradores de la plataforma pueden retirar o restaurar artículos. Se conservan los eventos originales.',
  ),
  hide: text('Withdraw article', '撤下文章', '撤下文章', 'Retirar artículo'),
  restore: text('Restore article', '恢复文章', '恢復文章', 'Restaurar artículo'),
  hidden: text('Withdrawn', '已撤下', '已撤下', 'Retirado'),
  visible: text('Public', '公开中', '公開中', 'Público'),
  read: text('Open article', '打开文章', '開啟文章', 'Abrir artículo'),
  empty: text(
    'No eligible city articles yet.',
    '目前没有可公开的城市文章。',
    '目前沒有可公開的城市文章。',
    'Aún no hay artículos de la ciudad.',
  ),
  older: text(
    'Older article ID · from its /news/ link',
    '更早的文章 ID · 位于 /news/ 链接中',
    '更早的文章 ID · 位於 /news/ 連結中',
    'ID de un artículo anterior · del enlace /news/',
  ),
};
export default function AdminCityNews({
  articles,
  locale,
  busy,
  onAction,
}: {
  articles: NewsRow[];
  locale: Locale;
  busy: boolean;
  onAction: (type: string, payload: Record<string, unknown>) => Promise<void>;
}) {
  const [id, setId] = useState('');
  const t = (key: keyof typeof copy) => copy[key][locale];
  const eligibleId = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
  return (
    <>
      <p className="muted small">{t('info')}</p>
      {!articles.length && <p className="muted">{t('empty')}</p>}
      {articles.map((article) => (
        <article className="admin-report" key={article.id}>
          <strong>{article.title}</strong>
          <small>
            {new Date(article.createdAt).toLocaleString(locale)} ·{' '}
            {t(article.publicHidden ? 'hidden' : 'visible')}
          </small>
          <a href={`/news/${article.id}?lang=${locale}`} target="_blank" rel="noopener noreferrer">
            {t('read')}
          </a>
          <button
            className="button soft compact"
            disabled={busy}
            onClick={() =>
              onAction('news.visibility', { eventId: article.id, hidden: !article.publicHidden })
            }
          >
            {t(article.publicHidden ? 'restore' : 'hide')}
          </button>
        </article>
      ))}
      <label>
        {t('older')}
        <input value={id} onChange={(e) => setId(e.target.value.trim())} maxLength={36} />
      </label>
      <div className="friend-actions">
        <button
          className="button soft compact"
          disabled={busy || !eligibleId}
          onClick={() => onAction('news.visibility', { eventId: id, hidden: true })}
        >
          {t('hide')}
        </button>
        <button
          className="button light compact"
          disabled={busy || !eligibleId}
          onClick={() => onAction('news.visibility', { eventId: id, hidden: false })}
        >
          {t('restore')}
        </button>
      </div>
    </>
  );
}
